import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface FloatingMessageContentProps {
  children: React.ReactNode;
}

const ContentComponent: React.FC<FloatingMessageContentProps> = ({
  children,
}) => {
  return <div className="peptalk-floating-message-content">{children}</div>;
};

export const Content: React.FC<FloatingMessageContentProps> = (
  props: FloatingMessageContentProps
) => {
  const Component = useCustomComponent({
    componentName: 'FloatingMessageContent',
    Component: ContentComponent,
  });

  return <Component {...props} />;
};
